import { motion } from 'framer-motion';
import Footer from '../components/Footer';

const WhoWeArePage = () => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        duration: 0.8,
        staggerChildren: 0.2
      }
    }
  };

  const itemVariants = {
    hidden: { y: 30, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: { duration: 0.6 }
    }
  };

  return (
    <div>
      <section className="pt-32 pb-20 bg-gradient-to-br from-tev-green to-tev-green-light">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="text-center text-white"
          >
            <h1 className="text-5xl font-bold mb-6">Who We Are</h1>
            <p className="text-xl max-w-3xl mx-auto opacity-90">
              Our focus is on food value chains and contributing to Africa's food security
            </p>
          </motion.div>
        </div>
      </section>

      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 gap-16 items-center mb-16">
            <motion.div
              variants={itemVariants}
              initial="hidden"
              animate="visible"
            >
              <h2 className="text-3xl font-semibold text-gray-900 mb-6">Who We Are</h2>
              <p className="text-lg text-gray-700 mb-6 leading-relaxed">
                Our focus is on food value chains. Through this, our business exists to solve one of the most consequential of human needs. 
                We are therefore committed to contributing to Africa's food security.
              </p>
              <p className="text-lg text-gray-700 mb-6 leading-relaxed">
                From seed propagation, irrigated agriculture, agro-processing and value addition, we intend to be a dependable partner in the 
                production of high quality, safe and nutritious food products.
              </p>
              
              <div className="bg-gradient-to-r from-green-50 to-emerald-50 p-6 rounded-lg mb-6">
                <h3 className="text-xl font-semibold text-gray-900 mb-4">Our Core Activities</h3>
                <div className="grid grid-cols-2 gap-4">
                  {['Seed Propagation', 'Irrigated Agriculture', 'Agro-Processing', 'Value Addition'].map((item, index) => (
                    <div key={index} className="flex items-center">
                      <i className="fas fa-check-circle text-tev-green mr-3"></i>
                      <span className="text-gray-700">{item}</span>
                    </div>
                  ))}
                </div>
              </div>
            </motion.div>
            
            <motion.div
              variants={itemVariants}
              initial="hidden"
              animate="visible"
              className="space-y-6"
            >
              <div className="relative">
                <img 
                  src="/images/nice.jpg" 
                  alt="Who We Are" 
                  className="rounded-lg shadow-lg w-full object-cover h-64"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent rounded-lg"></div>
              </div>
              <div className="relative">
                <img 
                  src="/images/who we are.jpg" 
                  alt="Our Operations" 
                  className="rounded-lg shadow-lg w-full object-cover h-64"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent rounded-lg"></div>
              </div>
            </motion.div>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            <motion.div
              variants={itemVariants}
              className="text-center"
            >
              <img 
                src="/images/seeds.jpg" 
                alt="Seed Propagation" 
                className="rounded-lg shadow-md mb-4 w-full h-48 object-cover"
              />
              <h3 className="font-semibold text-gray-900 mb-2">Seed Propagation</h3>
              <p className="text-gray-600">Quality seed development and propagation for sustainable agriculture</p>
            </motion.div>
            
            <motion.div
              variants={itemVariants}
              className="text-center"
            >
              <img 
                src="/images/irrigation.jpg" 
                alt="Irrigated Agriculture" 
                className="rounded-lg shadow-md mb-4 w-full h-48 object-cover"
              />
              <h3 className="font-semibold text-gray-900 mb-2">Irrigated Agriculture</h3>
              <p className="text-gray-600">Advanced irrigation systems for optimal crop growth</p>
            </motion.div>
            
            <motion.div
              variants={itemVariants}
              className="text-center"
            >
              <img 
                src="/images/process.jpg" 
                alt="Agro-Processing" 
                className="rounded-lg shadow-md mb-4 w-full h-48 object-cover"
              />
              <h3 className="font-semibold text-gray-900 mb-2">Agro-Processing</h3>
              <p className="text-gray-600">Modern facilities for value addition and quality assurance</p>
            </motion.div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default WhoWeArePage;
